// When does a ledger edit mean "a payment happened"?
//
// `paid` is effectively three-valued. The rest of the app treats null as paid
// (src/pages/Ledger/index.tsx sums with `paid !== false`), and the entry modal
// defaults a new row to paid. So the naive `!previous && next` is wrong twice
// over: it would fire on every null->true normalization, and it would miss the
// common case of recording a Zelle payment as a brand-new already-paid row.
//
// Getting this wrong is not cosmetic: a false negative means money that reached
// us never shows up on the facility's books.

export function isPaid(value: boolean | null | undefined): boolean {
  return value !== false;
}

export interface PaidTransition {
  isNew: boolean;
  /** `paid` as stored before this edit; ignored when isNew. */
  previous: boolean | null | undefined;
  /** `paid` as the form is about to save it. */
  next: boolean | null | undefined;
}

export function becamePaid(transition: PaidTransition): boolean {
  if (transition.isNew) return isPaid(transition.next);
  // Only an explicitly-unpaid row can transition. A row that was already
  // (implicitly) paid is being edited, not paid.
  return transition.previous === false && isPaid(transition.next);
}
